/* Diara Gallery: aligned masonry for product grids and the Artists page, plus adaptive artist profile layout.
   Cards are placed by a CSS grid with 1px rows; each card spans as many rows as it is tall,
   so columns start at the same height and shorter cards never leave gaps. */
(function () {
  'use strict';
  var GAP = 16;
  var seen = new WeakSet();
  var queued = false;
  var ro = 'ResizeObserver' in window ? new ResizeObserver(schedule) : null;

  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      layout();
    });
  }

  function watch(el) {
    if (ro && !seen.has(el)) { ro.observe(el); seen.add(el); }
  }

  function place(items) {
    items.forEach(function (el) {
      watch(el);
      var v = 'span ' + Math.max(1, Math.ceil(el.offsetHeight + GAP));
      if (el.style.gridRowEnd !== v) el.style.gridRowEnd = v;
    });
  }

  /* Artist profile: photo + statement. Short statements are centered beside the photo;
     long ones start at the top and the photo stays in view while reading. */
  function artistProfile() {
    var sec = document.querySelector('[id$="section_q3NgFr"]');
    if (!sec) return;
    var photo = sec.querySelector('.image-block');
    if (!photo || !photo.parentElement) return;
    var wrap = photo.parentElement;
    var text = photo.nextElementSibling;
    if (!text) return;
    wrap.classList.add('diara-bio');
    watch(photo);
    watch(text);
    var stacked = window.matchMedia('(max-width: 749px)').matches;
    var isLong = !stacked && text.offsetHeight > photo.offsetHeight + 40;
    wrap.classList.toggle('diara-bio--long', isLong);
  }

  function layout() {
    /* Collection pages */
    var grid = document.querySelector('ul.product-grid');
    if (grid) {
      var items = grid.querySelectorAll(':scope > li.product-grid__item');
      if (grid.getAttribute('product-grid-view') === 'zoom-out') {
        grid.classList.remove('diara-masonry');
        items.forEach(function (li) { li.style.gridRowEnd = ''; });
      } else {
        grid.classList.add('diara-masonry');
        place(items);
      }
    }
    /* Artist profile pages: product lists shown as grids */
    document.querySelectorAll('.section-resource-list .resource-list--grid').forEach(function (list) {
      list.classList.add('diara-masonry-rl');
      place(list.querySelectorAll(':scope > .resource-list__item'));
    });
    /* Artists page: portrait cards */
    document.querySelectorAll('.diara-artists-grid').forEach(function (list) {
      list.classList.add('diara-masonry-ag');
      place(list.querySelectorAll(':scope > a.diara-artist-card'));
    });
    artistProfile();
  }

  /* Homepage: make the text under each round category button link to the same page as the circle. */
  function linkLabels() {
    document.querySelectorAll('a.text-inherit').forEach(function (a) {
      if (!a.querySelector('.icon-block__media')) return;
      var icon = a.closest('.icon-block');
      var label = icon && icon.nextElementSibling;
      if (!label || label.querySelector('a')) return;
      var wrap = document.createElement('a');
      wrap.href = a.getAttribute('href');
      wrap.className = 'text-inherit diara-label-link';
      while (label.firstChild) wrap.appendChild(label.firstChild);
      label.appendChild(wrap);
    });
  }

  function start() {
    layout();
    linkLabels();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    document.addEventListener('shopify:section:load', linkLabels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
